import pick from 'lodash/pick'

let filterValues = {}
let dashboardFilter = '';
let url = new URL(document.location)
url.searchParams.forEach((value, key) => {
  if (key === 'filter') {
    filterValues = JSON.parse(atob(value))
    dashboardFilter = value;
  // backwards support with old URL arg:
  } else if (key === 'filterValues') {
    filterValues = JSON.parse(value)
  }
})

//on page load ...


// Initial state
const state = {
  filters: {}, // Filters data
  filterValues, // Selected values
  modals: [], // Modals of Widgets
  dashboardFilter
}

// Getters
const getters = {
  filters: (state, getters, rootState) => state.filters,
  filterValues: (state, getters, rootState) => state.filterValues,
  filterValuesByKeys: (state, getters) => filterKeys => pick(getters.filterValues, filterKeys),
  modals: (state, getters) => state.modals,
  dashboardFilter: (state, getters, rootState) => state.dashboardFilter
}

// Mutations
const mutations = {
  /**
   * Register filter by server-side class name
   *
   * @param {object} state - State
   * @param {object} payload
   * @param {object} payload.filter - Filter to register
   */
  registerFilter (state, { filter }) {
    const filterKey = filter.filter

    state.filters[filterKey] = filter
  },

  updateFilterValues (state, values) {
    let url = new URL(document.location)
    // url.search = 'filterValues=' + encodeURIComponent(JSON.stringify(values))
    let filterData = btoa(JSON.stringify(values))
    url.search = 'filter=' + filterData;
    state.dashboardFilter = filterData;
    window.history.replaceState('', '', url)
    state.filterValues = values
  },

  showModal(state, modal) {
    window.onbeforeunload = function () {
      return "Are you sure you want to navigate away from this Dashboard screen, or do you just want to close the modal?"
    }
    state.modals.push(modal)
  },

  hideModal(state, id) {
    //
  }
}

// actions
const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
